import React, { useCallback } from 'react'
import { useStyles } from './styles'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import { ArtistNote } from 'components/artist-dashboard/artist-note/ArtistNote'

export const ArtistNotes = ({ notes, onNoteEdit }) => {
    const classes = useStyles()

    const createNote = useCallback(() => {
        const emptyNote = { body: '' }
        onNoteEdit(emptyNote)
    }, [onNoteEdit])

    return (
        <div className={classes.widget}>
            <div className={classes.topBar}>
                <CallToActionButton display="inline" onClick={createNote} text="Create new note" />
            </div>
            <div className={classes.notes}>
                {Array.isArray(notes) &&
                    notes.map(note => <ArtistNote onClick={() => onNoteEdit(note)} key={note._id} body={note.body} />)}
            </div>
        </div>
    )
}
